import { Arrange } from "@aviary";
import { FlipperPriceBlur } from "@shared/components/FlipperPriceBlur/FlipperPriceBlur";
import { Price } from "@shared/components/Price/Price";
import type { PriceDisplayColor } from "@shared/components/Price/Price";

import * as styles from "./ProductUnitPricing.styles";

interface Props {
  sellPrice: number;
  promotionPrice?: number;
  displayColor?: PriceDisplayColor;
}

const ProductUnitPricing = ({ sellPrice, promotionPrice, displayColor }: Props) => {
  if (!promotionPrice || sellPrice === promotionPrice) {
    return (
      <FlipperPriceBlur>
        <Price
          price={sellPrice}
          displayColor={displayColor}
          data-testid="sellPrice"
          data-e2e="sell-price"
          css={styles.sellPrice}
        />
      </FlipperPriceBlur>
    );
  }

  return (
    <Arrange isWrapped={false} spacing="xsmall">
      <s data-testid="strike">
        <FlipperPriceBlur>
          <Price price={sellPrice} data-testid="sellPrice" data-e2e="sell-price" />
        </FlipperPriceBlur>
      </s>
      <div css={styles.sellPrice}>
        <FlipperPriceBlur>
          <Price
            price={promotionPrice}
            displayColor={displayColor}
            data-testid="PromotionPrice"
            data-e2e="promotion-price"
          />
        </FlipperPriceBlur>
      </div>
    </Arrange>
  );
};

export { ProductUnitPricing };
